import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import phoneNumber from 'legacy/utils/phoneNumber'

import { type Employee } from '../domain/Employee'

export function mapEmployeesToSelect(employees: Employee[]) {
  return employees.map(employee => ({
    label: employee.name || employee.phoneNumber,
    value: employee.uuid,
  }))
}

export function formatEmployeePhone(employee: Employee) {
  return phoneNumber.format(employee.phoneNumber, '+X (XXX) XXX-XXXX')
}

export function formatEmployeeRoles(employee: Employee) {
  return employee.roles.map(toCapitalizeFirstLetter).join(', ')
}

export function formatEmployeeName({ name, phoneNumber }: Employee) {
  return name || phoneNumber
}
